<template>
  <div
    :class="state.system.theme"
    id="theme"
    v-shortkey="['ctrl', 'alt', 'shift', '|']"
    @shortkey="getSettings"
  >
    <div class="dashboard">
      <div class="overlay-loader" v-if="$loading">
        <div class="wrap">
          <div id="pulse1" style="z-index: 2; position: absolute"></div>
          <div id="pulse2" style="z-index: 1; position: absolute"></div>
        </div>
        <!--  <div class="loader">
          <div class="loaderBar"></div>
        </div>-->
      </div>

      <!--   <div class="overlay" v-if="$loading">
        <div class="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>-->
      <b-modal
        size="sm"
        ref="show-meesage-box"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header
      >
        <div v-if="state.notifications.message.type == 'invoice_summary'">
          <h6 class="mb-3">Invoice generated</h6>
        </div>
        <div class="">
          <p class="mb-2 pb-0" v-html="showMsg.text" />
        </div>
        <template slot="modal-footer" class="pt-0">
          <div
            class="message-footer"
            v-if="
              state.notifications.message.type != 'decide' &&
                state.notifications.message.type != 'cancel_return' &&
                state.notifications.message.type != 'no_internet'
            "
          >
            <b-button
              @click="logout"
              variant="primary"
              block
              :disabled="
                state.sessions.loading &&
                  state.notifications.message.type != 'logout'
              "
              >{{ showMsg.btnText }}</b-button
            >
          </div>
          <div
            class="message-footer"
            v-if="state.notifications.message.type == 'cancel_return'"
          >
            <b-button
              @click="cancelReturnInOffline"
              block
              variant="danger"
              :disabled="state.sessions.loading"
              v-text="showMsg.btnText"
            />
          </div>
          <div
            class="message-footer float-right"
            v-if="state.notifications.message.type == 'no_internet'"
          >
            <b-button
              @click="logout"
              variant="primary"
              v-if="!isOffline"
              v-text="showMsg.btnText"
            />
          </div>
          <div
            class="message-footer"
            v-if="state.notifications.message.type == 'decide'"
          >
            <b-row>
              <b-col
                md="6"
                class="pr-1"
                v-if="state.billing.billing.order.data == ''"
              >
                <b-button @click="decide('cancel')" variant="danger" block
                  >Cancel Bill</b-button
                >
              </b-col>
              <b-col
                :md="state.billing.billing.order.data != '' ? '12' : '6'"
                :class="state.billing.billing.order.data != '' ? '' : 'pl-1'"
              >
                <b-button @click="decide('continue')" variant="primary" block
                  >Continue</b-button
                >
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
      <alert-popup
        :message="$store.state.notifications.showAlert.message"
        :type="$store.state.notifications.showAlert.type"
        :show="$showAlert"
      />
      <update-app-alert />
      <slot name="content"></slot>
      <navbar ref="navbar" />
    </div>

    <!-- Message Box -->
    <message-box
      :open="$store.state.notifications.messageBox.open"
      @close-message="flushError"
      :message="$store.state.notifications.messageBox"
    />
  </div>
</template>

<script>
import Navbar from "../components/Nav";
import AlertPopup from "../components/AlertPopup";
import { mapState } from "vuex";
import * as helper from "../helper";
import UpdateAppAlert from "../components/UpdateAppAlert";
import MessageBox from "../components/MessageBox";

export default {
  name: "dashboard",
  components: {
    Navbar,
    AlertPopup,
    UpdateAppAlert,
    MessageBox,
  },
  data() {
    return {
      alert: false,
    };
  },
  watch: {
    $loading() {
      if (this.$loading == true) {
        //  console.log("Show loading");
        // this.$refs["show-meesage-box"].show();
      } else {
        //  console.log("Hide loading");
      }
    },
    showMsg: {
      handler(val) {
        if (val.text != "") {
          console.log("Show Message");
          this.$refs["show-meesage-box"].show();
        } else {
          console.log("Hide Message");
          this.$loading = false;
          this.$refs["show-meesage-box"].hide();
        }
      },
      deep: true,
    },
    $showAlert() {
      if (this.$showAlert == true) {
        setTimeout(() => {
          this.$showAlert = false;
          // this.$store.commit("resetAlert");
        }, 3000);
        // console.log("Show Alert");
        // this.$refs["show-meesage-box"].show();
      } else {
        //  console.log("Hide Alert");
      }
    },
    showMessage: {
      handler(val) {
        if (val.message != "") {
          this.$showAlert = true;
        }
      },
      deep: true,
    },
    globalLoading() {
      if (this.state.sessions.loading == true) {
        this.$loading = true;
      } else {
        this.$loading = false;
      }
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    showMsg() {
      return this.state.notifications.message;
    },
    showMessage() {
      return this.state.notifications.showAlert;
    },
    globalLoading() {
      return this.state.sessions.loading;
    },
  },
  mounted() {
    // var find = document.getElementsByClassName("dashboard");
    // console.log(find);
    // if(isOffline == true){
    //   find.className += "offline";
    // }
    // else{
    //   find.className -= "offline";
    // }

    this.$store.commit("notifications/clearMessage");
    // this.$store.commit("resetAlert");
  },
  methods: {
    cancelReturnInOffline() {
      this.$store.commit("billing/setBillingMode", "normal");
      this.$store.commit("billing/setRefundMode", false);
      if (this.state.billing.billing.order.data != "") {
        helper.cancelReturnInOffline();
      } else {
        this.$refs["show-meesage-box"].hide();
      }
    },
    logout() {
      this.$refs["show-meesage-box"].hide();
      if (this.state.notifications.message.type == "logout") {
        this.$store.dispatch("sessions/logout").then(() => {
          this.$router.push("/");
        });
      } else if (this.state.notifications.message.type == "invoice_summary") {
        this.$store.dispatch("billing/newBill");
        this.$router.replace({
          path: `/order-summary/${
            _.split(
              _.split(this.state.notifications.message.text, "ID ")[1],
              "<br>"
            )[0]
          }`,
        });
      }
      this.$store.commit("notifications/clearMessage");
    },
    decide(type) {
      this.$refs["show-meesage-box"].hide();
      if (type == "continue") {
        this.$store.commit("system/forceOfflineStatus", true);
        this.$store.commit("system/setConnected", true);
      } else if (type == "cancel") {
        helper.syncApiToken();
      }
      this.$store.commit("notifications/clearMessage");
    },
    flushError() {
      this.$store.commit("notifications/clearMessageBox");
    },
    getSettings() {
      this.$store.dispatch("system/getLatestSettings");
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  background: rgba(8, 8, 8, 0.5);
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
